<button
  [type]="type()"
  [disabled]="disabled()"
  [class]="classes()"
  [attr.form]="form()"
  [attr.data-active]="active()"
  [attr.tabindex]="tabIndex()"
  [attr.aria-label]="ariaLabel()">
  <ng-content></ng-content>
</button>
